export class ReportPartAllocationRequestAccumulationType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
}
